import styled from 'styled-components';
import Box from 'component/layoutComponents/Box/Box';
import { TextField } from '@mui/material';
import Col from 'component/layoutComponents/Col/Col';
import { IThemeProps } from 'component/theme';

export const StyledDeviceCart = styled(Box)`
  ${({ theme }) => `
    border-top: 1px solid #CCCCCC;
    padding: 24px 0;
    h5{
      color: rgba(0, 0, 0, 0.87);
    }
    h6, p{
      color: rgba(0, 0, 0, 0.6);
    }
  `
}`;
export const StyledTextField = styled(TextField)(({ theme }) => `
  &:not(:last-of-type) {
    margin-bottom: ${theme.uptimeSpace[16]}px;
  }

  .MuiFormHelperText-root {
    margin-left: auto;
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${theme.uptimeColors.mainTheme.primary};
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.uptimeColors.mainTheme.primary};
  }
`);

export const StyledProductImage = styled(Box)`
  text-align: center;
  img{
    width: 180px;
    height: 100%;
  }
`;

export const StyledCartQuantity = styled(Box) `
  ${({ theme, ...props } : IThemeProps & { isSoftware?: boolean}) => `
    display: flex;
    justify-content: space-between;
    height: 100%;
    margin-right: ${props.isSoftware ? 'unset' : theme.uptimeSpace[10]}px;
  `}
`;

export const StyledBoxEyeBrow = styled(Box)`
  ${({ theme }) => `
    svg{
      font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
    }
  `}
`;

export const StyledColReason = styled(Col)`
  ${({ theme }) => `
  @media screen and (min-width: ${theme.breakpoints.lg}) {
    padding-left: ${theme.uptimeSpace[18]}px !important;
  }
  `}
`